module.exports = __webpack_public_path__ + "static/herovid_landing-150025764566cdb830f3643c12c22f3c.mp4";